import { CAPTURE_FULL } from "./buildings";
import { overflowGoldForJoin } from "./reducer/helpers";
import { normalizedHpDisplay, unitTotalHp } from "./stacks";
import type { Tile, Unit } from "./types";
import { MAX_HP } from "./units";

export interface JoinPreview {
  fromHp: number;
  intoHp: number;
  resultHp: number;
  refund: number;
}

export function previewJoin({ source, target }: { source: Unit; target: Unit }): JoinPreview {
  const fromHp = unitTotalHp(source);
  const intoHp = unitTotalHp(target);
  const combined = fromHp + intoHp;
  const resultHp = Math.min(MAX_HP, combined);
  const refund = overflowGoldForJoin(source.kind, Math.max(0, combined - MAX_HP));
  return { fromHp, intoHp, resultHp, refund };
}

export interface CapturePreview {
  from: number;
  to: number;
  full: number;
}

export function previewCapture({ tile, unit }: { tile: Tile; unit: Unit }): CapturePreview {
  const remaining = tile.capturePoints ?? CAPTURE_FULL;
  const from = CAPTURE_FULL - remaining;
  const to = Math.min(CAPTURE_FULL, from + normalizedHpDisplay(unit.hp));
  return { from, to, full: CAPTURE_FULL };
}
